// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import './index.css';

// Konfiguroi AWS Amplify asetuksilla, jotka on määritelty aws-exports.js:ssä
Amplify.configure(awsconfig);

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
